module.exports = __webpack_public_path__ + "static/img/b01.c44d32d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/b01.jpg
// module id = IF2i
// module chunks = 1